import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import {  SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'




export const services = [
    {
      icon: 'fas fa-calendar-day',
      title: 'Exceptional Performance',
      subtitle:
        	'High fidelity double stranded DNA probes with optimized performance thanks to probe boosting and efficient amplification.	NGS QC of all probes with Uniform enrichment of target regions with no unexpected dropouts and unparalleled specificity even at high sequencing depths.'
        
        
    },

    
    {
      icon: 'fas fa-memory',
      title: 'Maximum Capture Efficiency',
      subtitle:
        ' ⦁	High enrichment uniformity means you can increase the depth of sequencing, or throughput to reduced overall sequencing cost',
    },
    {
      icon: 'fas fa-dna',
      title: 'Greater Flexibility',
      subtitle:
        "⦁	Modular kit structure enables workflow flexibility , ⦁	Customization tools allow the rapid and scalable implementation of custome exome ",
    },
  ];

const useStyles = makeStyles(theme => ({
  font:{
    fontSize:'18px'

  },

  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const  Colonal= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
     
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
     
                <br />
                <Typography component="span" variant="inherit" color="primary">
               Colonal Genes
                </Typography>
              </span>
            }
            subtitle="Unleash the full power of a well-designed library. With Twist, you are assured that the library you design contains the specific modifications, exactly where you want them, saving you valuable resources for the downstream screening process. 

            Precisely crafted . "
     
            align="left"
            disableGutter
            titleVariant="h3"
          />

<br/>

<h2>
Precision Editing of Target Loci 
</h2>



          <ul  className = {classes.font}>
        
            <li >
       
            Highly accurate synthesis for specific targeting 
           
            </li>
            <li>
      
            Low error rate, 1:1000 nt 

            </li>
            

            <br/>
<h3>
Maximized Screening Efficiency 
</h3>



            <li>
            Highly uniform synthesis ensures oligo representation 

     

            </li>
            <li>

            Less than 90% of oligos represented within 4x of the mean 
           

            </li>

<br/>

            <h3>
            Library Designs Made Easy 
            </h3>
            <li>

            Custom CRISPR sgRNA design services through Desktop genetics 

            </li>

            <li>
            Optimized algorithms for highest activity and specificity 
            </li>
            
            <li>
            Compatible with many downstream cloning methods 
            </li>

          </ul>
          <SectionHeader
             ctaGroup={[
              <Button variant="contained" color="primary" size="large">
               Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
           Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
            />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/Twist/colonal_bSQupbxq9.png?updatedAt=1627464021060"
            alt="Colonal"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
Colonal.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Colonal;
